import type { Rule } from 'antd/es/form';
import i18n from '../i18n';

export const validateMultiEmail = (_: Rule, value: string[]): Promise<void> => {
  if (!value || value.length === 0) {
    return Promise.resolve();
  }

  const invalidEmails = value.filter(
    (email: string) =>
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
  );

  if (invalidEmails.length > 0) {
    return Promise.reject(
      new Error(
        `${i18n.t('validator.emailError')}: ${invalidEmails.join(', ')}`
      )
    );
  }

  return Promise.resolve();
};

export const validateEmail = (_: Rule, value: string): Promise<void> => {
  if (!value || value.length === 0) {
    return Promise.resolve();
  }

  if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
    return Promise.reject(new Error(i18n.t('validator.emailError')));
  }

  return Promise.resolve();
};
